import React, { FunctionComponent } from 'react';

// MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Common
import { GENERAL } from '../../constants';

// Components
import { Form } from '../Form';

// Properties
import * as styles from './Main.styles';

const Main: FunctionComponent = () => {
    return (
        <Container sx={styles.main} component="main">
            <Grid container>
                <Grid item xs={12}>
                    <Box sx={styles.box}>
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={styles.title}
                        >
                            {GENERAL.MAIN_TITLE}
                        </Typography>
                        <Typography variant="body2">
                            {GENERAL.MAIN_DESCRIPTION[1]}
                            <br />
                            {GENERAL.MAIN_DESCRIPTION[2]}
                            <Box
                                component="span"
                                sx={styles.italic}
                            >
                                {GENERAL.MAIN_DESCRIPTION[3]}
                            </Box>
                            {GENERAL.MAIN_DESCRIPTION[4]}
                            <Box
                                component="span"
                                sx={styles.italic}
                            >
                                {GENERAL.MAIN_DESCRIPTION[5]}
                            </Box>
                            {GENERAL.MAIN_DESCRIPTION[6]}
                            <Box
                                component="span"
                                sx={styles.italic}
                            >
                                {GENERAL.MAIN_DESCRIPTION[7]}
                            </Box>
                            {GENERAL.MAIN_DESCRIPTION[8]}
                            <Box
                                component="span"
                                sx={styles.italic}
                            >
                                {GENERAL.MAIN_DESCRIPTION[9]}
                            </Box>
                            {GENERAL.MAIN_DESCRIPTION[10]}
                          <Box
                            component="span"
                            sx={styles.italic}
                          >
                            {GENERAL.MAIN_DESCRIPTION[11]}
                          </Box>
                          {GENERAL.MAIN_DESCRIPTION[12]}
                        </Typography>
                    </Box>
                    <Form/>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Main;
